import script from "./ow-view-appointments-check.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-view-appointments-check.vue?vue&type=script&setup=true&lang=js"

import "./ow-view-appointments-check.vue?vue&type=style&index=0&id=2b8a2b98&lang=scss"

const __exports__ = script;

export default __exports__